import React, { useState, useRef } from "react";
import { Button } from "react-bootstrap";

const ProductFileUploadForm = (props) => {
  const [isHide, setIsHide] = useState(true);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [fileNames, setFilenames] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const savingRef = useRef(false);
  const titleRef = useRef("");
  const detailRef = useRef("");

  const onFilesChange = (e) => {
    for (let i = 0; i < e.target.files.length; i++) {
      const f = e.target.files[i];
      setSelectedFiles((prevState) => [...prevState, f]);
      setFilenames((prevState) => [...prevState, f.name]);
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (savingRef.current || props.disabled) return;
    savingRef.current = true;
    setSaving(true);
    setError("");
    try {
      await props.onSubmit(
        {
          title: titleRef.current.value,
          detail: detailRef.current.value,
        },
        selectedFiles
      );
      titleRef.current.value = "";
      detailRef.current.value = "";
      setFilenames([]);
      setIsHide(true);
      setSelectedFiles([]);
    } catch (error) {
      setError(error.message || "Cannot save files. Please try again.");
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  };

  const onCancel = () => {
    titleRef.current.value = "";
    detailRef.current.value = "";
    setIsHide(true);
    setFilenames([]);
    setSelectedFiles([]);
    setError("");
  };

  return (
    <>
      <div className="col-xl-9 col-lg-12 mb-5">
        <b>{props.text ? props.text : "Add File"}</b>
        {props.disabledReason && <div className="text-muted mt-2">{props.disabledReason}</div>}
        {error && <div className="alert alert-danger mt-2" role="alert">{error}</div>}

        <div className="col-xl-12 col-lg-12 pl-0">
          <div className="input-group mt-3">
            <input
              type="text"
              className="form-control"
              placeholder="Title..."
              ref={titleRef}
              disabled={saving || props.disabled}
              onFocus={() => {
                setIsHide(false);
              }}
            />
          </div>
          {!isHide && (
            <>
              <textarea
                className="form-control mt-3 mb-3"
                rows="3"
                placeholder="Add description here..."
                ref={detailRef}
                disabled={saving || props.disabled}
              />
              <div className="basic-form custom_file_input">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <span className="input-group-text">Upload</span>
                  </div>
                  <div className="custom-file">
                    <input
                      type="file"
                      multiple
                      className="custom-file-input"
                      onChange={onFilesChange}
                      aria-label="Files to upload"
                      disabled={saving || props.disabled}
                    />
                    <label className="custom-file-label">
                      {fileNames.join(", ") || "Choose file"}
                    </label>
                  </div>
                </div>
              </div>
              <div className="form-group row ml-1">
                <Button className="sm" onClick={onSubmit} disabled={saving || props.disabled}>
                  {saving ? "Saving..." : "Save"}
                </Button>
                <Button className="sm ml-2" variant="light" onClick={onCancel} disabled={saving}>
                  Cancel
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ProductFileUploadForm;
